import React from 'react';
import './footnotes.scss';

function Footnotes() {
  const footnotesData = [
    'National Institute of Mental Health. Major depression among adults. Accessed March 1, 2024. https://www.nimh.nih.gov/health/statistics/major-depression',
    'Key substance use and mental health indicators in the United States: Results from the 2022 National Use Survey on Drug Use and Health. SAMHSA. Accessed April 17, 2024. https://www.samhsa.gov/data/sites/default/files/reports/rpt42731/2022-nsduh-nnr.pdf',
    [
      ['Rush AJ et al. ', 'Am J Psychiatry', '. 2006;163(11):1905-1917'],
      ['reg', 'italic', 'reg']
    ],
    'National Alliance on Mental Illness. Types of medication. Accessed March 1, 2024. https://www.nami.org/About-Mental-Illness/Treatments/Mental-Health-Medications/Types-of-Medication',
    'SPRAVATO® [Prescribing Information]. Titusville, NJ: Janssen Pharmaceuticals, Inc.'
  ];

  return (
    <ul className="footnotes">
      {footnotesData.map((data, i) => {
        return (
          <li className="footnotes__li" key={`footnotes_${i}`}>
            <sup>{i + 1}</sup>
            {typeof data === 'string'
              ? data
              : data[0].map((text, i) => {
                  return (
                    <span className={data[1][i] === 'italic' ? 'footnotes--italic' : ''}>
                      {text}
                    </span>
                  );
                })}
          </li>
        );
      })}
    </ul>
  );
}

export default Footnotes;
